import {useEffect, useState} from "react";

const KEY = "theme";

function initial() {
  const saved = localStorage.getItem(KEY);
  if (saved === "light" || saved === "dark") return saved;
  return "light"; // paper is the designed default; dark is opt-in
}

export function useTheme() {
  const [theme, setTheme] = useState(initial);

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem(KEY, theme);
  }, [theme]);

  return [theme, () => setTheme(t => (t === "dark" ? "light" : "dark"))];
}
